import { render, staticRenderFns } from "./generar-rips.vue?vue&type=template&id=5976e400"
import script from "./generar-rips.vue?vue&type=script&lang=js"
export * from "./generar-rips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports